var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape1 = function SvgShape1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 91,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.765 71C4.573 63.582.843 54.007.843 43.554c0-23.56 18.95-42.66 42.328-42.66 10.58 0 20.254 3.913 27.675 10.38C78.249 4.808 87.9.895 98.456.895c23.323 0 42.229 19.1 42.229 42.66 0 10.453-3.721 20.028-9.898 27.446 6.177 7.418 9.898 16.993 9.898 27.445 0 23.561-18.906 42.66-42.23 42.66-10.555 0-20.206-3.912-27.61-10.38-7.42 6.468-17.093 10.38-27.674 10.38-23.377 0-42.328-19.099-42.328-42.66 0-10.452 3.73-20.027 9.922-27.445",
    opacity: 0.1
  })));
};
export default SvgShape1;